export default __webpack_public_path__ + "static/media/slogan.1eb80104.svg";